<template>
  <v-dialog
    v-model="dialogIsShown"
    scrollable
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        text
        x-small
      >
        Politique de confidentialité
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="white--text secondary pa-4">
        Politique de confidentialité
      </v-card-title>

      <v-card-text
        v-html="description"
        class="pa-4"
      ></v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-center">
        <v-btn
          text
          @click="dialogIsShown = false"
        >
          Fermer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LegalNoticeDialog',

  props: {
    value: Boolean,
  },

  data: () => ({
    description: `
      <!--<p>
        Votre candidature, lorsqu'elle est recevable, est versée dans notre
        <b>réserve de recrutement</b>
        prioritaire pour l'année académique 2021-2022 et ce, en application du Décret du 24
        juillet 1997 fixant le statut des membres du personnel directeur et enseignant et du
        personnel auxiliaire d'éducation des Hautes Ecoles organisées ou subventionnées par la
        Communauté française ou du Décret du 20 juin 2008 relatif aux membres du personnel
        administratif des Hautes Ecoles.
      </p>
      <p>
        Conformément au règlement du Parlement européen et du Conseil du 27 avril 2016 relatif à la
        protection des personnes physiques à l'égard du traitement des 
        <b>données à caractère personnel</b>
        et à la libre circulation de ces données, toutes les informations recueillies à l'occasion
        de votre postulation sont enregistrées et conservées, d'une part, pour les besoins de votre
        dossier de candidature et, d'autre part, pour la constitution de votre dossier dans le cas
        d'un engagement futur. Seules les personnes habilitées auront accès à vos données. Elles ne
        seront pas transférées à des tiers et seront conservées pendant un délai de 5 ans. Le
        traitement de ces données est sécurisé.
      </p>
      <p>
        Vous pouvez, à tout moment, accéder aux informations vous concernant, les rectifier ou les
        supprimer en vous adressant à Madame Jennifer DEMOL à l'adresse e-mail suivante:
        <a href="mailto:jennifer.demol@hainaut.be">jennifer.demol@hainaut.be</a>.
      </p>-->


      <h2 style="text-align: center;">Politique de confidentialité</h2>
      <br>
      <p>
        La politique de confidentialité explique de façon transparente la manière dont la Province de Hainaut traite vos données à caractère personnel.
      </p>
      <p><b>Le responsable du traitement est le Collège provincial, situé à la rue verte, 13 à 7000 Mons.</b>Pour accomplir ses missions, la Province de Hainaut est tenue de traiter vos données à caractère personnel conformément aux dispositions du Règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016 relatif à la protection des personnes physiques à l'égard du traitement des données à caractère personnel et à la libre circulation de ces données et de la loi du 30 juillet 2018 relative à la protection des personnes physiques à l'égard des traitements de données à caractère personnel et aux réglementations en matière de sécurité de l'information.</p>
      <p><b> Vos droits</b> : Vous disposez d'une <b>série de droits</b> (accès, information, rectification, portabilité, effacement (droit à l'oubli), limitation, opposition, retrait de consentement) conformément aux articles 15 à 22 du Règlement Général sur la
      Protection des Données à caractère personnel (RGPD), vous permettant de ne pas rester totalement passif par rapport à
      l'utilisation de vos données.</p>
      <p>
      Cette demande d'exercice des droits (qui doit être accompagnée de toute pièce justifiant de votre identité) ou toute
      demande d'information est à adresser au <b>Délégué à la protection des données (DPO)</b> soit :</p>
      <ul>
      <li>par lettre adressée à la cellule DPO, avenue Général de Gaulle, 102 à 7000 MONS</li>
      <li>par e-mail à l'adresse électronique suivante : info.dpo@hainaut.be</li>
      </ul>
      </p>
      <p>
        <b>Sécurité et confidentialité des données</b> : La Province de Hainaut met en œuvre les mesures techniques et
        organisationnelles afin de garantir un niveau de sécurité adapté au risque inhérent à ses opérations de traitement, répondre
        aux exigences règlementaires et protéger vos droits et vos données dès la conception des opérations de traitement.
        Si la Province traite des images, vidéos et enregistrements vocaux, elle s'engage à ne pas les utiliser à des fins
        commerciales et s'interdit de toute exploitation à des fins préjudiciables, contraire à la loi ou pouvant porter atteinte à la
        vie privée / réputation. Elle s'efforcera dans la mesure du possible, de tenir à disposition un justificatif de chaque diffusion
        sur simple demande. De plus, elle encouragera ses partenaires à faire de même et à mettre en œuvre tous les moyens
        nécessaires
        à
        la
        réalisation
        de
        cet
        objectif.
      </p>
      <p>
        <b>Voies de recours</b> : Sans préjudice de tout autre recours administratif ou juridictionnel, vous avez le droit d'introduire
        une réclamation auprès de l'Autorité de protection des données si vous considérez que vos droits ne sont pas respectés
        ou qu'un traitement de données à caractère personnel vous concernant constitue une violation du RGPD. Pour introduire
        une réclamation, adressez une demande à l'adresse suivante : Autorité de protection des données, rue de la Presse 35 à
        1000 Bruxelles (E-mail : contact@apd-gba.be)
      </p>
      <p><b>Mise à jour</b> : La présente politique est susceptible de faire l'objet d'éventuelles mises à jour. Il est dès lors demandé de la relire épisodiquement afin d'en être informé(e).</p>

      <h2 style="text-align: center;">Gestion des emplois vacants au sein de la Haute Ecole Condorcet</h2>
      <br>
      <p><strong><span style="text-decoration: underline;">Description</span></strong></p>
      <p>La liste des emplois vacants fait l'objet d'une parution au Moniteur belge. Les postulations sont, d&eacute;sormais, exclusivement<br />num&eacute;riques via le site www.olympe.condorcet.be. &Agrave; cet effet, un compte utilisateur sera requis. Une adresse personnelle,<br />qui n'appartient pas au domaine @condorcet.be, sera utilis&eacute;e pour remplir les formalit&eacute;s. Les personnes int&eacute;ress&eacute;es sont<br />invit&eacute;es &agrave; soumettre leur candidature en ligne, accompagn&eacute;e des documents attestant de leurs titres et m&eacute;rites (curriculum<br />vitae, dipl&ocirc;mes, d&eacute;cisions &eacute;ventuelles d'exp&eacute;rience utile...), au plus tard &agrave; la date fix&eacute;e. Il est &eacute;galement possible de<br />joindre une lettre de motivation (qui pourrait reprendre une photo du candidat). Ces donn&eacute;es recueillies permettent de<br />mesurer les aptitudes professionnelles. Tous les candidats recevront une notification &eacute;lectronique relative &agrave; la recevabilit&eacute;<br />de leur candidature et &agrave; la suite y r&eacute;serv&eacute;e. La candidature, lorsqu'elle est recevable, est vers&eacute;e dans une r&eacute;serve de<br />recrutement, et ce en application du D&eacute;cret du 24 juillet 1997 fixant le statut des membres du personnel directeur et<br />enseignant et du personnel auxiliaire d'&eacute;ducation des Hautes Ecoles organis&eacute;es ou subventionn&eacute;es par la Communaut&eacute;<br />fran&ccedil;aise ou du D&eacute;cret du 20 juin 2008 relatif aux membres du personnel administratif des Hautes Ecoles.</p>
      <p><span style="text-decoration: underline;"><strong>Responsable de Traitement</strong> </span>: Coll&egrave;ge Provincial, Rue Verte 13 - 7000 MONS</p>
      <p><span style="text-decoration: underline;"><strong>Cat&eacute;gories de personnes</strong></span></p>
      <ul>
      <li>Citoyens</li>
      <li>Personnel enseignant et non-enseignant</li>
      </ul>
      <p><span style="text-decoration: underline;"><strong>Principaux types de donn&eacute;es &agrave; caract&egrave;re personnel</strong></span></p>
      <ul>
      <li>Donn&eacute;es d'identification</li>
      <li>Composition du m&eacute;nage / &eacute;tat-civil</li>
      <li>Caract&eacute;ristiques personnelles</li>
      <li>Loisirs et int&eacute;r&ecirc;ts</li>
      <li>&Eacute;tudes et formations</li>
      <li>Profession et emploi</li>
      <li>Enregistrements d&rsquo;images et/ou de sons</li>
      </ul>
      <p><span style="text-decoration: underline;"><strong>Liste exhaustive de toutes les donn&eacute;es &agrave; caract&egrave;re personnel de ce traitement</strong></span></p>
      <p>Pour la cr&eacute;ation du compte utilisateur : Nom - Pr&eacute;nom - Date de naissance - nationalit&eacute; - sexe - adresse - T&eacute;l&eacute;phone -<br />adresse mail priv&eacute;e - identifiant et mot de passe Les pi&egrave;ces jointes : curriculum vitae, dipl&ocirc;mes, d&eacute;cisions &eacute;ventuelles<br />d'exp&eacute;rience utile, formations suivies, exp&eacute;riences professionnelles. Dans le curriculum vitae et/ou lettre de motivation:<br />l'&eacute;tat civil / composition de m&eacute;nage / centres d'int&eacute;r&ecirc;ts, &eacute;ventuellement une photo,</p>
      <p><span style="text-decoration: underline;"><strong>Lic&eacute;it&eacute;</strong></span> : Consentement</p>
      <p><strong><span style="text-decoration: underline;">Existe-t-il des cat&eacute;gorie(s) sp&eacute;cifiques(s) de donn&eacute;es concern&eacute;es faisant l'objet d'une n&eacute;cessit&eacute; absolue et de garanties</span></strong><br /><strong><span style="text-decoration: underline;">appropri&eacute;es ?</span></strong> Non</p>
      <p><strong><span style="text-decoration: underline;">Base(s) l&eacute;gale(s)</span> </strong>: Oui</p>
      <p>Votre candidature, lorsqu'elle est recevable, est vers&eacute;e dans une r&eacute;serve de recrutement, et ce en application du D&eacute;cret<br />du 24 juillet 1997 fixant le statut des membres du personnel directeur et enseignant et du personnel auxiliaire d'&eacute;ducation<br />des Hautes Ecoles organis&eacute;es ou subventionn&eacute;es par la Communaut&eacute; fran&ccedil;aise ou du D&eacute;cret du 20 juin 2008 relatif aux<br />membres du personnel administratif des Hautes Ecoles.</p>
      <p><span style="text-decoration: underline;"><strong>Principales cat&eacute;gories de destinataires</strong></span></p>
      <ul>
      <li>La personne enregistr&eacute;e elle-m&ecirc;me</li>
      <li>Employeur ou relations de travail de la personne enregistr&eacute;e</li>
      </ul>
      <p><span style="text-decoration: underline;"><strong>Transfert</strong></span> : Pas de transfert</p>
      <p><span style="text-decoration: underline;"><strong>Conservation - Dur&eacute;e et motivation</strong></span></p>
      <p>Les donn&eacute;es seront conserv&eacute;es pendant un d&eacute;lai de 5 ans dans le cadre d'une r&eacute;serve de recrutement &agrave; venir</p>
      <p><span style="text-decoration: underline;"><strong>Droits des personnes concern&eacute;es li&eacute;s &agrave; ce traitement</strong></span></p>
      <ul>
      <li>Droit d'information</li>
      <li>Droit d'acc&egrave;s</li>
      <li>Droit de rectification</li>
      <li>Droit &agrave; la portabilit&eacute;</li>
      <li>Droit &agrave; l'effacement</li>
      </ul>
      <p>Droit de rectification limit&eacute; &agrave; l'erreur de plume.</p>
    `,
  }),

  computed: {
    dialogIsShown: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
